(function () {
    'use strict';
    var m = angular.module('auth');
    m.factory('trialExpiredModal', ["modals", "feature", function (modals, feature) {
        return {
            show: function () {
                var brandServiceName = '';
                function showModal(params) {
                    var queryString = Object.keys(params).map(function (key) {
                        return key + '=' + params[key];
                    }).join('&');
                    window.location.href = '/alert_page.html?' + queryString;
                }
                if (feature.checkpointTheme) {
                    brandServiceName = 'Check Point CloudGuard SaaS';
                    var params = {
                        theme: 'checkpointTheme',
                        content: 'Dear User, Your ' + brandServiceName + ' trial has expired. Please contact your ' + brandServiceName + ' representative.',
                        title: 'Trial Expired'
                    };
                    return showModal(params);
                } else if (feature.lastlineTheme) {
                    brandServiceName = 'Lastline Cloud Security';
                } else if (feature.sonicwallTheme) {
                    brandServiceName = 'SonicWall Cloud Application Security';
                } else {
                    brandServiceName = 'Avanan';
                }
                return modals.alert('Dear User, Your ' + brandServiceName + ' trial has expired. Please contact your ' + brandServiceName + ' representative.', {
                    title: 'Trial Expired',
                    disableCloseX: true,
                    backdrop: 'static',
                    keyboard: false,
                    notCloseOnRouteChange: true
                });
            }
        };
    }]);
}());